module.exports = __webpack_public_path__ + "static/media/right_circle.8962c954.svg";